<template>
<v-layout row wrap>
    <v-flex xs12>
        <v-card>
            <v-card-text primary-title>
                <v-layout row wrap>
                    <template v-if="editMode || !currentSponsorship.id">
                        <v-flex xs12>
                            <v-text-field
                                label="Placeholder"
                                color="green"
                                v-model="form.placeholder"
                                ref="placeholder"
                                required
                                :rules="rules.required"
                                @input="onFormChange"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                label="Descripción"
                                color="green"
                                v-model="form.description"
                                ref="description"
                                required
                                :rules="rules.required"
                                @input="onFormChange"></v-text-field>
                        </v-flex>
                    </template>
                    <template v-if="!editMode && currentSponsorship.id">
                        <v-flex xs12><strong>Placeholder: </strong>{{ form.placeholder }}</v-flex>
                        <v-flex xs12><strong>Descripción: </strong>{{ form.description }}</v-flex>
                    </template>
                    <v-flex xs12 v-if="typesWithOptionsRequired.includes( type )">
                        <v-layout row wrap>
                            <v-flex xs12 v-bind:class="{ 'options-button-margin': lang === 'en' }">
                                <span class="green--text">Opciones</span>
                                <v-btn
                                    v-if="lang === 'es'"
                                    icon
                                    color="green"
                                    @click="addOption">
                                    <v-icon>add</v-icon>
                                </v-btn>
                            </v-flex>
                                <template
                                    v-for="( item, i ) in form.options">
                                    <v-flex xs12 v-if="optionsEditMode[ i ] || !currentSponsorship.id" :key="i">
                                        <v-text-field
                                            label="Opción"
                                            color="green"
                                            v-model="form.options[ i ].text"
                                            ref="options"
                                            required
                                            :rules="rules.required"
                                            @input="onFormChange"></v-text-field>
                                    </v-flex>
                                    <template v-if="!optionsEditMode[ i ] && currentSponsorship.id">
                                        <v-flex xs10>
                                            <p><strong>Opción: </strong>{{ form.options[ i ].text }}</p>
                                        </v-flex>
                                        <v-flex xs1>
                                            <v-btn
                                                v-if="lang === 'es'"
                                                icon
                                                flat
                                                color="red"
                                                @click="deleteOption( i )">
                                                <v-icon>delete</v-icon>
                                            </v-btn>
                                        </v-flex>
                                        <v-flex xs1>
                                            <v-btn
                                                icon
                                                flat
                                                color="green"
                                                @click="changeOptionMode( i )">
                                                <v-icon>edit</v-icon>
                                            </v-btn>
                                        </v-flex>
                                    </template>
                                    <v-flex xs12 d-flex align-right v-if="optionsEditMode[ i ]">
                                        <v-btn small color="red" @click="changeOptionMode( i )">Cancelar</v-btn>
                                        <v-btn small color="green" @click="updateOption( i )">Guardar</v-btn>
                                    </v-flex>
                                </template>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-flex>
    <add-options-evidence-modal
        :dialog="showAddOptionsModal"
        :evidenceId="form.evidence_id"
        @close="showAddOptionsModal = false"></add-options-evidence-modal>
</v-layout>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import AddOptionsEvidenceModal from './addOptionsEvidenceModal';

export default {
    name: 'EvidencesCard',
    props: {
        lang: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        evidencePos: {
            type: Number,
            required: true
        },
        editMode: {
            type: Boolean,
            default: false
        },
        numberOfOptions: 0
    },
    data() {
        return {
            evidenceIdSelected: null,
            showAddOptionsModal: false,
            optionsEditMode: [],
            typesWithOptionsRequired: [
                'radio_list',
                'checkbox_list',
                'select_list',
                'select_list_related',
                'select_list_other',
            ],
            form: {
                lang: this.lang,
                placeholder: '',
                description: '',
                evidence_id: -1,
                options: []
            },
            rules: {
                required: [
                    val =>  ((val === 0 ? '0' : String(val)) || '').length > 0 || 'Este campo es obligatorio'
                ]
            }
        };
    },
    components: {
        AddOptionsEvidenceModal
    },
    created() {
        
        this.initializeOptions();
    },
    computed: {
        ...mapGetters([
            'currentSponsorship'
        ])
    },
    watch: {
        numberOfOptions( newVal, oldVal ) {
            this.form.options.push({ text: '' });
        },
        currentSponsorship( newVal, oldVal ) {
            
            this.initializeOptions();
        }
    },
    methods: {
        ...mapActions([
            'editOptionEvidence',
            'deleteOptionEvidence',
            'loadSponsorship'
        ]),
        initializeOptions() {

            if ( this.currentSponsorship.id ) {
            
                this.form.evidence_id = this.currentSponsorship.evidences[ this.evidencePos ].id;
                this.form.placeholder = this.currentSponsorship.evidences[ this.evidencePos ][`placeholder_${ this.lang }`];
                this.form.description = this.currentSponsorship.evidences[ this.evidencePos ][`description_${ this.lang }`];

                this.optionsEditMode = [];
                this.form.options = [];
                this.currentSponsorship.evidences[ this.evidencePos ].options.forEach( option => {

                    this.optionsEditMode.push(false);
                    const translation = { ...option.translations.find( opt => opt.language === this.lang) };
                    this.form.options.push({
                        option_id: option.id,
                        ...translation,
                        text: translation.name
                    })
                });
            }
        },
        addOption() {

            if ( !this.currentSponsorship.id ) {

                this.form.options.push({ text: '' });
                this.$emit( 'optionWasAdded' );
            } else {

                this.showAddOptionsModal = true;
            }

        },
        hasErrors() {

            let hasError = false;

            Object.keys( this.form ).forEach( key => {
                if ( !Array.isArray( this.form[ key ] ) ) {

                    if ( key !== 'lang' && key !== 'evidence_id' ) {

                        hasError = this.form[ key ] === null || this.form[ key ] === '' || hasError;
                        this.$refs[ key ].validate( true );
                    }
                } else {

                    this.form[ key ].forEach( ( item, itemPos ) => {
                        
                        hasError = item.text === null || item === '' || hasError;
                        this.$refs[ key ][ itemPos ].validate( true );
                    })
                }

            });

            return hasError;

        },
        onFormChange() {

            this.$emit( 'update', this.form );
        },
        cleanFormOnCancel() {

            this.form.placeholder = this.currentSponsorship.evidences[ this.evidencePos ][ `placeholder_${ this.lang }` ];
            this.form.description = this.currentSponsorship.evidences[ this.evidencePos ][ `description_${ this.lang }` ];
            this.onFormChange();
        },
        changeOptionMode( i ) {

            Vue.set(this.optionsEditMode, i, !this.optionsEditMode[i]);
        },
        updateOption( i ) {

            const data = {
                id: this.form.options[ i ].id,
                language: this.lang,
                name: this.form.options[ i ].text 
            };

            this.editOptionEvidence({ data, callback: response => this.changeOptionMode( i ) });
        },
        deleteOption( i ) {
            
            this.deleteOptionEvidence({ id: this.form.options[ i ].option_id, callback: response => this.loadSponsorship({ id: this.$route.params.id }) })
        }
    },
}
</script>
<style>
    .options-button-margin {
        margin-bottom: 27px;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/sponsorships/evidencesCard.vue